import {API_URL} from 'constants/API';

interface IProps<T> {
  baseQuery: string;
  queryObject?: T | string;
}

export const queryBuilder = <T>({baseQuery, queryObject}: IProps<T>) => {
  const query = new URL(baseQuery, API_URL);

  if (queryObject) {
    Object.entries(queryObject).forEach(([key, value]) => {
      if (!value) return;
      query.searchParams.append(key, value);
    });
  }

  const decodedQueryString = decodeURIComponent(query.toString());

  return decodedQueryString.replace(API_URL || '', '');
};
